export default "__VITE_ASSET__DKc9oam3__"